var map = {
	"./decidim/avatar-multiuser.png": 16050,
	"./decidim/brands/facebook.svg": 55780,
	"./decidim/brands/google.svg": 91933,
	"./decidim/brands/twitter-x.svg": 73902,
	"./decidim/cc-badge.png": 84236,
	"./decidim/decidim-logo.svg": 77024,
	"./decidim/default-avatar.svg": 22424,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 91364,
	"./decidim/icons.svg": 2803,
	"./decidim/pattern.png": 90436,
	"./decidim/placeholder-card-g.svg": 37169,
	"./decidim/placeholder-card-l.svg": 49818,
	"./decidim/placeholder.jpg": 29257,
	"./decidim/remixicon.symbol.svg": 59613,
	"./decidim/vendor/social-share-button/douban.svg": 588,
	"./decidim/vendor/social-share-button/email.svg": 48521,
	"./decidim/vendor/social-share-button/facebook.svg": 70975,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 56289,
	"./decidim/vendor/social-share-button/hacker_news.svg": 81449,
	"./decidim/vendor/social-share-button/linkedin.svg": 47849,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 57354,
	"./decidim/vendor/social-share-button/pinterest.svg": 19247,
	"./decidim/vendor/social-share-button/reddit.svg": 947,
	"./decidim/vendor/social-share-button/telegram.svg": 72038,
	"./decidim/vendor/social-share-button/tumblr.svg": 28805,
	"./decidim/vendor/social-share-button/twitter.svg": 60248,
	"./decidim/vendor/social-share-button/vkontakte.svg": 92374,
	"./decidim/vendor/social-share-button/wechat.svg": 87505,
	"./decidim/vendor/social-share-button/whatsapp.svg": 25049,
	"./decidim/vendor/social-share-button/x.svg": 41169,
	"./decidim/vendor/social-share-button/xing.svg": 38783
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88099;